import { createContext } from "react";
import { organizationState } from "../states/organization.state";

const context = createContext(organizationState);

export default context;
